export default __webpack_public_path__ + "static/media/kycVerificationhelpHighlight.743c322a.png";